import { GoogleApiWrapper as Wrapper } from 'google-maps-react';
import isFunction from "lodash/isFunction";
import { Loader } from '../widgets/loading/loader/Loader';
const mapOptionsFromProps = function mapOptionsFromProps({
  googleMapsApiKey: apiKey
}) {
  return {
    LoadingContainer: Loader,
    apiKey: isFunction(apiKey) ? apiKey() : apiKey
  };
};
export const GoogleMapsApiWrapper = ComponentToWrap => Wrapper(mapOptionsFromProps)(ComponentToWrap);